import React from 'react';
import { marcaDelEntorno } from '../utils/identidad';

/* El nombre de la plataforma con su vertical: "Udream App CRM".

   Las tres son la misma Udream App y se distinguen por la última palabra y su
   color —verde el CRM, azul el portal, dorado el super admin—, el mismo código
   de color que ya usan los íconos y los degradés. Un solo componente para que
   no se desincronicen: el nombre sale del entorno, nunca escrito a mano.

   Dos tonos porque el mismo color no sirve en los dos fondos: sobre el degradé
   oscuro hace falta uno brillante, y sobre el papel claro del login uno
   saturado, o no se lee. */
export default function MarcaApp({ tono = 'oscuro', style, className }) {
  const m = marcaDelEntorno();
  return (
    <span className={className} style={style}>
      Udream App <b style={{ color: tono === 'claro' ? m.colorClaro : m.color, fontWeight: 800 }}>{m.sufijo}</b>
    </span>
  );
}
